(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AEGov", [], factory);
	else if(typeof exports === 'object')
		exports["AEGov"] = factory();
	else
		root["AEGov"] = factory();
})(self, function() {
return 